export const ONLY_LETTERS_AND_SPACES_REGEX = /^[a-zA-Z\s]*$/gi;
export const ONLY_START_WITH_LETTER_REGEX = /^([^\W\d_][a-zA-Z\s]*?)*$/gi;
export const ONLY_EMAIL_REGEX = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/gi;
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W])[A-Za-z\d\W]{8,}$/gi;
export const SIMPLE_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/gi;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const REMOVE_WHITE_SPACE =/\s+/g;
export const REMOVE_SPECIAL_CHARACTERS=/[^a-zA-Z\s]/g;
